import React from 'react';
import './RemoveDraftModal.scss';

interface RemoveDraftModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const RemoveDraftModal: React.FC<RemoveDraftModalProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  if (!isOpen) return null;

  return (
    <div className="remove-draft-modal-overlay">
      <dialog
        className="remove-draft-modal"
        aria-modal="true"
        aria-labelledby="remove-draft-modal-title"
      >
        <button
          className="remove-draft-modal__close-button"
          onClick={onClose}
          aria-label="Close remove draft modal"
        >
          ✕
        </button>
        <div className="remove-draft-modal__header">
          <h2 id="remove-draft-modal-title" className="remove-draft-modal__title">
            Are you sure you want to remove this draft?
          </h2>
        </div>
        
        <div className="remove-draft-modal__content">
          <p className="remove-draft-modal__message">
            This action cannot be undone.
          </p>
        </div>
        
        <div className="remove-draft-modal__footer">
          <div className="remove-draft-modal__footer-container">
            <div className="remove-draft-modal__footer-buttons">
              <auro-button
                className="remove-draft-modal__cancel-button"
                onClick={onClose}
                aria-label="Cancel remove draft"
                variant='secondary'
                size='md'
              >
                No, cancel
              </auro-button>
              <auro-button
                className="remove-draft-modal__remove-button"
                onClick={onConfirm}
                aria-label="Confirm remove draft"
                variant='primary'
                size='md'
              >
                Yes, remove
              </auro-button>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
};

export default RemoveDraftModal;